import React from 'react';
import { useIntl } from 'react-intl';

import globalMessages from 'messages';

interface Props {
    betsSize: number | null;
}

const BetCount: React.FC<Props> = ({ betsSize }) => {
    const { formatMessage } = useIntl();

    const betCountTitle = betsSize
        ? formatMessage(globalMessages.bettingSlipBetTitle, {
              count: betsSize,
          })
        : '';

    return (
        <div className="__app-BetCount-container">
            {betsSize + ' ' + betCountTitle}
        </div>
    );
};

export default BetCount;
